module.exports = __webpack_public_path__ + "static/media/cf_ic_bond.6ecef0ed.png";